<template>
  <div class="app_warp">
    <router-view/>
    <tabbar-top/>
    <tabbar/>
  </div>
</template>

<script>
import TabbarTop from '@/components/TabbarTop'
import Tabbar from '@/components/Tabbar'

export default {
  name: 'Layout',
  components: {
    TabbarTop, Tabbar
  }
}
</script>

<style scoped lang="scss">
</style>
